import { TextValueType } from 'utils/constants';

export const SourceOfComplaintList = [
  'Face to face',
  'Email',
  'Online form',
  'Phone',
  'Post',
  'Referral from AFCA',
  'Social media',
  'Web chat',
  'Other',
];

// Moved to util/constants
// export const AllowedFileTypes = ['doc', 'docx', 'eml', 'jpeg', 'jpg', 'pdf', 'png', 'xls'];
// export const AllowedFileTypesCombined = get(window, '_CMS_.ALLOWED_FILE_EXTENSIONS', []);

export const ProductTypeList = [
  'Accident & Health',
  'Business Pack',
  'Farm',
  'Home – Building & Contents',
  'Home – Building Only',
  'Home – Contents Only',
  'Landlord',
  'Lenders Mortgage Insurance',
  'Motor',
  'Motorcycle',
  'Residential Strata',
  'Other',
];

export const OutcomeTypeList = [
  'Maintained - no compensation/action',
  'Maintained - apology/non-financial remedy',
  'Maintained - nominal compensation ex-gratia',
  'Maintained - nominal compensation commercial',
  'Split in favour of QBE',
  'Split in favour of customer',
  'Settled - in full (merits)',
  'Settled - in full (ex-gratia)',
  'Settled - in full (commercial)',
  'Settled - in part (merits)',
  'Settled - in part (ex-gratia)',
  'Settled - in part (commercial)',
  'Settled - apology/non-financial remedy',
];

export const SalesCategoryList: TextValueType[] = [
  {
    text: 'Policy/Product',
    value: 'PolicyProduct',
  },
  {
    text: 'Premium/Pricing',
    value: 'PremiumPricing',
  },
  {
    text: 'Documentation',
    value: 'Documentation',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
  {
    text: 'Marketing',
    value: 'Marketing',
  },
  {
    text: 'Service',
    value: 'SalesService',
  },
];

export const ClaimCategoryList: TextValueType[] = [
  {
    text: 'Assessment/Repair',
    value: 'AssessmentRepair',
  },
  {
    text: 'Denial',
    value: 'Denial',
  },
  {
    text: 'Settlement Amount',
    value: 'SettlementAmount',
  },
  {
    text: 'Recovery',
    value: 'Recovery',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
  {
    text: 'Service',
    value: 'ClaimsService',
  },
  {
    text: 'Settlement Method',
    value: 'SettlementMethod',
  },
];

export const FinancialHardshipCategoryList: TextValueType[] = [
  {
    text: 'Service',
    value: 'HardshipService',
  },
  {
    text: 'Outcome',
    value: 'Outcome',
  },
  {
    text: 'Privacy',
    value: 'Privacy',
  },
];
